import React from "react";
import SubFilter from "./components/SubFilter";

// Abuelo: SubFilterSearch.jsx
export default function SubFilterSearch({
  vCategoriesSelected,
  setVCategoriesSelected,
}) {
  const normalizedCategories = vCategoriesSelected.map(Number);

  return (
    <div className="filtros-barra-busqueda">
      <SubFilter
        vCategoriesSelected={normalizedCategories}
        setVCategoriesSelected={setVCategoriesSelected}
      />
    </div>
  );
}

